import { default as categories8nh6LZJDqZMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/cms/categories.vue?macro=true";
import { default as indexEJTeqQ2OsFMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/enrolment/closeYear/index.vue?macro=true";
import { default as index7nFZZ2vJj1Meta } from "/tmp/8ddac70b7b64d3d/pages/admin/enrolment/list/index.vue?macro=true";
import { default as indexg9EPk04wKBMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/enrolment/process/index.vue?macro=true";
import { default as registerMg54RC86HDMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/enrolment/register.vue?macro=true";
import { default as listG5fCRbPvcpMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/finance/list.vue?macro=true";
import { default as paymentsmE7oWJ25RcMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/finance/payments.vue?macro=true";
import { default as borrowPwOUJhcfjHMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/library/borrow.vue?macro=true";
import { default as homeZnzWsjpDwPMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/library/home.vue?macro=true";
import { default as loansbhtidBUrkcMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/library/loans.vue?macro=true";
import { default as searcherLV3vAwT74SMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/library/searcher.vue?macro=true";
import { default as managerTAnT6AvsxFMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/mgsystems/manager.vue?macro=true";
import { default as indexTKZVAgjFSkMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/school/cohort/index.vue?macro=true";
import { default as indexVJzecXaMPkMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/school/curriculum/index.vue?macro=true";
import { default as index7yly4fMh8UMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/school/dua/index.vue?macro=true";
import { default as indexFsL4Q8EbmLMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/school/evaluationSystems/index.vue?macro=true";
import { default as indexlm07Z1QBkrMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/school/lnut/index.vue?macro=true";
import { default as indexNTuc5fQ2AlMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/school/rooms/index.vue?macro=true";
import { default as indexn39UrPUl9lMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/system/config/index.vue?macro=true";
import { default as indexekFwsKGIN4Meta } from "/tmp/8ddac70b7b64d3d/pages/admin/system/profile/index.vue?macro=true";
import { default as indexdUZR7LqUFgMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/system/roles/index.vue?macro=true";
import { default as indexCMtpRq4v7WMeta } from "/tmp/8ddac70b7b64d3d/pages/admin/system/simpleEnrolments/index.vue?macro=true";
import { default as admisionesWdOGJfy9t8Meta } from "/tmp/8ddac70b7b64d3d/pages/admisiones.vue?macro=true";
import { default as indexEfCqV6wcY0Meta } from "/tmp/8ddac70b7b64d3d/pages/agenda/index.vue?macro=true";
import { default as chatN4sex4LC2mMeta } from "/tmp/8ddac70b7b64d3d/pages/chat.vue?macro=true";
import { default as _91_46_46_46slug_935sMtkNu8xOMeta } from "/tmp/8ddac70b7b64d3d/pages/cicle/home/[id]/[subject]/[[tab]]/[[subid]]/[...slug].vue?macro=true";
import { default as _91slug_93e6467jtUIOMeta } from "/tmp/8ddac70b7b64d3d/pages/circulares/[category]/[slug].vue?macro=true";
import { default as indexpKPl8JHbc6Meta } from "/tmp/8ddac70b7b64d3d/pages/circulares/[category]/index.vue?macro=true";
import { default as indexrToYkMjnWtMeta } from "/tmp/8ddac70b7b64d3d/pages/circulares/index.vue?macro=true";
import { default as _91slug_93z28E2TTneYMeta } from "/tmp/8ddac70b7b64d3d/pages/cms/[category]/[slug].vue?macro=true";
import { default as indexSRx9yz9eW0Meta } from "/tmp/8ddac70b7b64d3d/pages/cms/[category]/index.vue?macro=true";
import { default as _91id_930fhx2Rge6AMeta } from "/tmp/8ddac70b7b64d3d/pages/cms/banner/[id].vue?macro=true";
import { default as _91id_93ZqEoRe4cEoMeta } from "/tmp/8ddac70b7b64d3d/pages/cms/home/[id].vue?macro=true";
import { default as contactozAzkm5GYAvMeta } from "/tmp/8ddac70b7b64d3d/pages/contacto.vue?macro=true";
import { default as mynF8XBk6ioWMeta } from "/tmp/8ddac70b7b64d3d/pages/finance/my.vue?macro=true";
import { default as forgotPasswordXyu4TdAXNqMeta } from "/tmp/8ddac70b7b64d3d/pages/forgotPassword.vue?macro=true";
import { default as listrkG7StauF2Meta } from "/tmp/8ddac70b7b64d3d/pages/hhrr/employees/list.vue?macro=true";
import { default as eppsdFSFPhyWfaMeta } from "/tmp/8ddac70b7b64d3d/pages/hhrr/profesiogram/epps.vue?macro=true";
import { default as examsH3MkevmlZXMeta } from "/tmp/8ddac70b7b64d3d/pages/hhrr/profesiogram/exams.vue?macro=true";
import { default as jobsagGZb0iohoMeta } from "/tmp/8ddac70b7b64d3d/pages/hhrr/profesiogram/jobs.vue?macro=true";
import { default as manager8gkfmuSBkJMeta } from "/tmp/8ddac70b7b64d3d/pages/hhrr/risk/manager.vue?macro=true";
import { default as risks3AAIQoLQBuMeta } from "/tmp/8ddac70b7b64d3d/pages/hhrr/risk/risks.vue?macro=true";
import { default as home1Ceu6WTLReMeta } from "/tmp/8ddac70b7b64d3d/pages/home.vue?macro=true";
import { default as myOewvayNIWGMeta } from "/tmp/8ddac70b7b64d3d/pages/incidents/my.vue?macro=true";
import { default as indexC2wjQBRTwpMeta } from "/tmp/8ddac70b7b64d3d/pages/index.vue?macro=true";
import { default as linksCua9Shw5IZMeta } from "/tmp/8ddac70b7b64d3d/pages/links.vue?macro=true";
import { default as _91_91tab_93_93YUFz5xYcYjMeta } from "/tmp/8ddac70b7b64d3d/pages/lnut/home/[id]/[section]/[[pk]]/[[tab]].vue?macro=true";
import { default as _91tab_93E5Yz1eLbCgMeta } from "/tmp/8ddac70b7b64d3d/pages/lnut/home/subject/[id]/[tab].vue?macro=true";
import { default as loginxH0Vgy57u8Meta } from "/tmp/8ddac70b7b64d3d/pages/login.vue?macro=true";
import { default as logoutpaetVycIHaMeta } from "/tmp/8ddac70b7b64d3d/pages/logout.vue?macro=true";
import { default as noticiasRYBGGBoFjZMeta } from "/tmp/8ddac70b7b64d3d/pages/noticias.vue?macro=true";
import { default as _91tab_93mbYeAsoQqVMeta } from "/tmp/8ddac70b7b64d3d/pages/profile/settings/[tab].vue?macro=true";
import { default as _91token_938hI16pHzMwMeta } from "/tmp/8ddac70b7b64d3d/pages/resetPassword/[token].vue?macro=true";
import { default as licenciapYAuIRy6ylMeta } from "/tmp/8ddac70b7b64d3d/pages/rules/licencia.vue?macro=true";
import { default as manualwOER7cXCN7Meta } from "/tmp/8ddac70b7b64d3d/pages/rules/manual.vue?macro=true";
import { default as politicasnXsmSPLaMxMeta } from "/tmp/8ddac70b7b64d3d/pages/rules/politicas.vue?macro=true";
import { default as terminosVyAiehEmOSMeta } from "/tmp/8ddac70b7b64d3d/pages/rules/terminos.vue?macro=true";
import { default as myZOpYLy7lufMeta } from "/tmp/8ddac70b7b64d3d/pages/schedule/my.vue?macro=true";
import { default as indexCAKZ60DvVBMeta } from "/tmp/8ddac70b7b64d3d/pages/school/assistance/entrance/index.vue?macro=true";
import { default as indexQOTwtyqbiOMeta } from "/tmp/8ddac70b7b64d3d/pages/school/assistance/report/index.vue?macro=true";
import { default as index9OvJCn5SrEMeta } from "/tmp/8ddac70b7b64d3d/pages/school/sico/index.vue?macro=true";
import { default as adminpiarCt73bo6YmJMeta } from "/tmp/8ddac70b7b64d3d/pages/school/tracing/adminpiar.vue?macro=true";
import { default as characterizationcsaM1XrcfNMeta } from "/tmp/8ddac70b7b64d3d/pages/school/tracing/characterization.vue?macro=true";
import { default as coursesFUl32gCqFaMeta } from "/tmp/8ddac70b7b64d3d/pages/school/tracing/courses.vue?macro=true";
import { default as lowPerformancer9VuT7sYS9Meta } from "/tmp/8ddac70b7b64d3d/pages/school/tracing/lowPerformance.vue?macro=true";
import { default as performancezHMb2y9A94Meta } from "/tmp/8ddac70b7b64d3d/pages/school/tracing/performance.vue?macro=true";
import { default as resources515cwnZxSWMeta } from "/tmp/8ddac70b7b64d3d/pages/school/tracing/resources.vue?macro=true";
import { default as indexlQxXugwV8ZMeta } from "/tmp/8ddac70b7b64d3d/pages/school/transport/index.vue?macro=true";
import { default as _91_46_46_46slug_93NXTlPEKNR8Meta } from "/tmp/8ddac70b7b64d3d/pages/subject/home/[id]/[tab]/[[subid]]/[...slug].vue?macro=true";
import { default as testrCljSyfougMeta } from "/tmp/8ddac70b7b64d3d/pages/test.vue?macro=true";
export default [
  {
    name: categories8nh6LZJDqZMeta?.name ?? "admin-cms-categories",
    path: categories8nh6LZJDqZMeta?.path ?? "/admin/cms/categories",
    meta: categories8nh6LZJDqZMeta || {},
    alias: categories8nh6LZJDqZMeta?.alias || [],
    redirect: categories8nh6LZJDqZMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/cms/categories.vue").then(m => m.default || m)
  },
  {
    name: indexEJTeqQ2OsFMeta?.name ?? "admin-enrolment-closeYear",
    path: indexEJTeqQ2OsFMeta?.path ?? "/admin/enrolment/closeYear",
    meta: indexEJTeqQ2OsFMeta || {},
    alias: indexEJTeqQ2OsFMeta?.alias || [],
    redirect: indexEJTeqQ2OsFMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/enrolment/closeYear/index.vue").then(m => m.default || m)
  },
  {
    name: index7nFZZ2vJj1Meta?.name ?? "admin-enrolment-list",
    path: index7nFZZ2vJj1Meta?.path ?? "/admin/enrolment/list",
    meta: index7nFZZ2vJj1Meta || {},
    alias: index7nFZZ2vJj1Meta?.alias || [],
    redirect: index7nFZZ2vJj1Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/enrolment/list/index.vue").then(m => m.default || m)
  },
  {
    name: indexg9EPk04wKBMeta?.name ?? "admin-enrolment-process",
    path: indexg9EPk04wKBMeta?.path ?? "/admin/enrolment/process",
    meta: indexg9EPk04wKBMeta || {},
    alias: indexg9EPk04wKBMeta?.alias || [],
    redirect: indexg9EPk04wKBMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/enrolment/process/index.vue").then(m => m.default || m)
  },
  {
    name: registerMg54RC86HDMeta?.name ?? "admin-enrolment-register",
    path: registerMg54RC86HDMeta?.path ?? "/admin/enrolment/register",
    meta: registerMg54RC86HDMeta || {},
    alias: registerMg54RC86HDMeta?.alias || [],
    redirect: registerMg54RC86HDMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/enrolment/register.vue").then(m => m.default || m)
  },
  {
    name: listG5fCRbPvcpMeta?.name ?? "admin-finance-list",
    path: listG5fCRbPvcpMeta?.path ?? "/admin/finance/list",
    meta: listG5fCRbPvcpMeta || {},
    alias: listG5fCRbPvcpMeta?.alias || [],
    redirect: listG5fCRbPvcpMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/finance/list.vue").then(m => m.default || m)
  },
  {
    name: paymentsmE7oWJ25RcMeta?.name ?? "admin-finance-payments",
    path: paymentsmE7oWJ25RcMeta?.path ?? "/admin/finance/payments",
    meta: paymentsmE7oWJ25RcMeta || {},
    alias: paymentsmE7oWJ25RcMeta?.alias || [],
    redirect: paymentsmE7oWJ25RcMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/finance/payments.vue").then(m => m.default || m)
  },
  {
    name: borrowPwOUJhcfjHMeta?.name ?? "admin-library-borrow",
    path: borrowPwOUJhcfjHMeta?.path ?? "/admin/library/borrow",
    meta: borrowPwOUJhcfjHMeta || {},
    alias: borrowPwOUJhcfjHMeta?.alias || [],
    redirect: borrowPwOUJhcfjHMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/library/borrow.vue").then(m => m.default || m)
  },
  {
    name: homeZnzWsjpDwPMeta?.name ?? "admin-library-home",
    path: homeZnzWsjpDwPMeta?.path ?? "/admin/library/home",
    meta: homeZnzWsjpDwPMeta || {},
    alias: homeZnzWsjpDwPMeta?.alias || [],
    redirect: homeZnzWsjpDwPMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/library/home.vue").then(m => m.default || m)
  },
  {
    name: loansbhtidBUrkcMeta?.name ?? "admin-library-loans",
    path: loansbhtidBUrkcMeta?.path ?? "/admin/library/loans",
    meta: loansbhtidBUrkcMeta || {},
    alias: loansbhtidBUrkcMeta?.alias || [],
    redirect: loansbhtidBUrkcMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/library/loans.vue").then(m => m.default || m)
  },
  {
    name: searcherLV3vAwT74SMeta?.name ?? "admin-library-searcher",
    path: searcherLV3vAwT74SMeta?.path ?? "/admin/library/searcher",
    meta: searcherLV3vAwT74SMeta || {},
    alias: searcherLV3vAwT74SMeta?.alias || [],
    redirect: searcherLV3vAwT74SMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/library/searcher.vue").then(m => m.default || m)
  },
  {
    name: managerTAnT6AvsxFMeta?.name ?? "admin-mgsystems-manager",
    path: managerTAnT6AvsxFMeta?.path ?? "/admin/mgsystems/manager",
    meta: managerTAnT6AvsxFMeta || {},
    alias: managerTAnT6AvsxFMeta?.alias || [],
    redirect: managerTAnT6AvsxFMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/mgsystems/manager.vue").then(m => m.default || m)
  },
  {
    name: indexTKZVAgjFSkMeta?.name ?? "admin-school-cohort",
    path: indexTKZVAgjFSkMeta?.path ?? "/admin/school/cohort",
    meta: indexTKZVAgjFSkMeta || {},
    alias: indexTKZVAgjFSkMeta?.alias || [],
    redirect: indexTKZVAgjFSkMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/school/cohort/index.vue").then(m => m.default || m)
  },
  {
    name: indexVJzecXaMPkMeta?.name ?? "admin-school-curriculum",
    path: indexVJzecXaMPkMeta?.path ?? "/admin/school/curriculum",
    meta: indexVJzecXaMPkMeta || {},
    alias: indexVJzecXaMPkMeta?.alias || [],
    redirect: indexVJzecXaMPkMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/school/curriculum/index.vue").then(m => m.default || m)
  },
  {
    name: index7yly4fMh8UMeta?.name ?? "admin-school-dua",
    path: index7yly4fMh8UMeta?.path ?? "/admin/school/dua",
    meta: index7yly4fMh8UMeta || {},
    alias: index7yly4fMh8UMeta?.alias || [],
    redirect: index7yly4fMh8UMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/school/dua/index.vue").then(m => m.default || m)
  },
  {
    name: indexFsL4Q8EbmLMeta?.name ?? "admin-school-evaluationSystems",
    path: indexFsL4Q8EbmLMeta?.path ?? "/admin/school/evaluationSystems",
    meta: indexFsL4Q8EbmLMeta || {},
    alias: indexFsL4Q8EbmLMeta?.alias || [],
    redirect: indexFsL4Q8EbmLMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/school/evaluationSystems/index.vue").then(m => m.default || m)
  },
  {
    name: indexlm07Z1QBkrMeta?.name ?? "admin-school-lnut",
    path: indexlm07Z1QBkrMeta?.path ?? "/admin/school/lnut",
    meta: indexlm07Z1QBkrMeta || {},
    alias: indexlm07Z1QBkrMeta?.alias || [],
    redirect: indexlm07Z1QBkrMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/school/lnut/index.vue").then(m => m.default || m)
  },
  {
    name: indexNTuc5fQ2AlMeta?.name ?? "admin-school-rooms",
    path: indexNTuc5fQ2AlMeta?.path ?? "/admin/school/rooms",
    meta: indexNTuc5fQ2AlMeta || {},
    alias: indexNTuc5fQ2AlMeta?.alias || [],
    redirect: indexNTuc5fQ2AlMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/school/rooms/index.vue").then(m => m.default || m)
  },
  {
    name: indexn39UrPUl9lMeta?.name ?? "admin-system-config",
    path: indexn39UrPUl9lMeta?.path ?? "/admin/system/config",
    meta: indexn39UrPUl9lMeta || {},
    alias: indexn39UrPUl9lMeta?.alias || [],
    redirect: indexn39UrPUl9lMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/system/config/index.vue").then(m => m.default || m)
  },
  {
    name: indexekFwsKGIN4Meta?.name ?? "admin-system-profile",
    path: indexekFwsKGIN4Meta?.path ?? "/admin/system/profile",
    meta: indexekFwsKGIN4Meta || {},
    alias: indexekFwsKGIN4Meta?.alias || [],
    redirect: indexekFwsKGIN4Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/system/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexdUZR7LqUFgMeta?.name ?? "admin-system-roles",
    path: indexdUZR7LqUFgMeta?.path ?? "/admin/system/roles",
    meta: indexdUZR7LqUFgMeta || {},
    alias: indexdUZR7LqUFgMeta?.alias || [],
    redirect: indexdUZR7LqUFgMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/system/roles/index.vue").then(m => m.default || m)
  },
  {
    name: indexCMtpRq4v7WMeta?.name ?? "admin-system-simpleEnrolments",
    path: indexCMtpRq4v7WMeta?.path ?? "/admin/system/simpleEnrolments",
    meta: indexCMtpRq4v7WMeta || {},
    alias: indexCMtpRq4v7WMeta?.alias || [],
    redirect: indexCMtpRq4v7WMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admin/system/simpleEnrolments/index.vue").then(m => m.default || m)
  },
  {
    name: admisionesWdOGJfy9t8Meta?.name ?? "admisiones",
    path: admisionesWdOGJfy9t8Meta?.path ?? "/admisiones",
    meta: admisionesWdOGJfy9t8Meta || {},
    alias: admisionesWdOGJfy9t8Meta?.alias || [],
    redirect: admisionesWdOGJfy9t8Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/admisiones.vue").then(m => m.default || m)
  },
  {
    name: indexEfCqV6wcY0Meta?.name ?? "agenda",
    path: indexEfCqV6wcY0Meta?.path ?? "/agenda",
    meta: indexEfCqV6wcY0Meta || {},
    alias: indexEfCqV6wcY0Meta?.alias || [],
    redirect: indexEfCqV6wcY0Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/agenda/index.vue").then(m => m.default || m)
  },
  {
    name: chatN4sex4LC2mMeta?.name ?? "chat",
    path: chatN4sex4LC2mMeta?.path ?? "/chat",
    meta: chatN4sex4LC2mMeta || {},
    alias: chatN4sex4LC2mMeta?.alias || [],
    redirect: chatN4sex4LC2mMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/chat.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_935sMtkNu8xOMeta?.name ?? "cicle-home-id-subject-tab-subid-slug",
    path: _91_46_46_46slug_935sMtkNu8xOMeta?.path ?? "/cicle/home/:id()/:subject()/:tab?/:subid?/:slug(.*)*",
    meta: _91_46_46_46slug_935sMtkNu8xOMeta || {},
    alias: _91_46_46_46slug_935sMtkNu8xOMeta?.alias || [],
    redirect: _91_46_46_46slug_935sMtkNu8xOMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/cicle/home/[id]/[subject]/[[tab]]/[[subid]]/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93e6467jtUIOMeta?.name ?? "circulares-category-slug",
    path: _91slug_93e6467jtUIOMeta?.path ?? "/circulares/:category()/:slug()",
    meta: _91slug_93e6467jtUIOMeta || {},
    alias: _91slug_93e6467jtUIOMeta?.alias || [],
    redirect: _91slug_93e6467jtUIOMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/circulares/[category]/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexpKPl8JHbc6Meta?.name ?? "circulares-category",
    path: indexpKPl8JHbc6Meta?.path ?? "/circulares/:category()",
    meta: indexpKPl8JHbc6Meta || {},
    alias: indexpKPl8JHbc6Meta?.alias || [],
    redirect: indexpKPl8JHbc6Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/circulares/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexrToYkMjnWtMeta?.name ?? "circulares",
    path: indexrToYkMjnWtMeta?.path ?? "/circulares",
    meta: indexrToYkMjnWtMeta || {},
    alias: indexrToYkMjnWtMeta?.alias || [],
    redirect: indexrToYkMjnWtMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/circulares/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93z28E2TTneYMeta?.name ?? "cms-category-slug",
    path: _91slug_93z28E2TTneYMeta?.path ?? "/cms/:category()/:slug()",
    meta: _91slug_93z28E2TTneYMeta || {},
    alias: _91slug_93z28E2TTneYMeta?.alias || [],
    redirect: _91slug_93z28E2TTneYMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/cms/[category]/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexSRx9yz9eW0Meta?.name ?? "cms-category",
    path: indexSRx9yz9eW0Meta?.path ?? "/cms/:category()",
    meta: indexSRx9yz9eW0Meta || {},
    alias: indexSRx9yz9eW0Meta?.alias || [],
    redirect: indexSRx9yz9eW0Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/cms/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_930fhx2Rge6AMeta?.name ?? "cms-banner-id",
    path: _91id_930fhx2Rge6AMeta?.path ?? "/cms/banner/:id()",
    meta: _91id_930fhx2Rge6AMeta || {},
    alias: _91id_930fhx2Rge6AMeta?.alias || [],
    redirect: _91id_930fhx2Rge6AMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/cms/banner/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93ZqEoRe4cEoMeta?.name ?? "cms-home-id",
    path: _91id_93ZqEoRe4cEoMeta?.path ?? "/cms/home/:id()",
    meta: _91id_93ZqEoRe4cEoMeta || {},
    alias: _91id_93ZqEoRe4cEoMeta?.alias || [],
    redirect: _91id_93ZqEoRe4cEoMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/cms/home/[id].vue").then(m => m.default || m)
  },
  {
    name: contactozAzkm5GYAvMeta?.name ?? "contacto",
    path: contactozAzkm5GYAvMeta?.path ?? "/contacto",
    meta: contactozAzkm5GYAvMeta || {},
    alias: contactozAzkm5GYAvMeta?.alias || [],
    redirect: contactozAzkm5GYAvMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/contacto.vue").then(m => m.default || m)
  },
  {
    name: mynF8XBk6ioWMeta?.name ?? "finance-my",
    path: mynF8XBk6ioWMeta?.path ?? "/finance/my",
    meta: mynF8XBk6ioWMeta || {},
    alias: mynF8XBk6ioWMeta?.alias || [],
    redirect: mynF8XBk6ioWMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/finance/my.vue").then(m => m.default || m)
  },
  {
    name: forgotPasswordXyu4TdAXNqMeta?.name ?? "forgotPassword",
    path: forgotPasswordXyu4TdAXNqMeta?.path ?? "/forgotPassword",
    meta: forgotPasswordXyu4TdAXNqMeta || {},
    alias: forgotPasswordXyu4TdAXNqMeta?.alias || [],
    redirect: forgotPasswordXyu4TdAXNqMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/forgotPassword.vue").then(m => m.default || m)
  },
  {
    name: listrkG7StauF2Meta?.name ?? "hhrr-employees-list",
    path: listrkG7StauF2Meta?.path ?? "/hhrr/employees/list",
    meta: listrkG7StauF2Meta || {},
    alias: listrkG7StauF2Meta?.alias || [],
    redirect: listrkG7StauF2Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/hhrr/employees/list.vue").then(m => m.default || m)
  },
  {
    name: eppsdFSFPhyWfaMeta?.name ?? "hhrr-profesiogram-epps",
    path: eppsdFSFPhyWfaMeta?.path ?? "/hhrr/profesiogram/epps",
    meta: eppsdFSFPhyWfaMeta || {},
    alias: eppsdFSFPhyWfaMeta?.alias || [],
    redirect: eppsdFSFPhyWfaMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/hhrr/profesiogram/epps.vue").then(m => m.default || m)
  },
  {
    name: examsH3MkevmlZXMeta?.name ?? "hhrr-profesiogram-exams",
    path: examsH3MkevmlZXMeta?.path ?? "/hhrr/profesiogram/exams",
    meta: examsH3MkevmlZXMeta || {},
    alias: examsH3MkevmlZXMeta?.alias || [],
    redirect: examsH3MkevmlZXMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/hhrr/profesiogram/exams.vue").then(m => m.default || m)
  },
  {
    name: jobsagGZb0iohoMeta?.name ?? "hhrr-profesiogram-jobs",
    path: jobsagGZb0iohoMeta?.path ?? "/hhrr/profesiogram/jobs",
    meta: jobsagGZb0iohoMeta || {},
    alias: jobsagGZb0iohoMeta?.alias || [],
    redirect: jobsagGZb0iohoMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/hhrr/profesiogram/jobs.vue").then(m => m.default || m)
  },
  {
    name: manager8gkfmuSBkJMeta?.name ?? "hhrr-risk-manager",
    path: manager8gkfmuSBkJMeta?.path ?? "/hhrr/risk/manager",
    meta: manager8gkfmuSBkJMeta || {},
    alias: manager8gkfmuSBkJMeta?.alias || [],
    redirect: manager8gkfmuSBkJMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/hhrr/risk/manager.vue").then(m => m.default || m)
  },
  {
    name: risks3AAIQoLQBuMeta?.name ?? "hhrr-risk-risks",
    path: risks3AAIQoLQBuMeta?.path ?? "/hhrr/risk/risks",
    meta: risks3AAIQoLQBuMeta || {},
    alias: risks3AAIQoLQBuMeta?.alias || [],
    redirect: risks3AAIQoLQBuMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/hhrr/risk/risks.vue").then(m => m.default || m)
  },
  {
    name: home1Ceu6WTLReMeta?.name ?? "home",
    path: home1Ceu6WTLReMeta?.path ?? "/home",
    meta: home1Ceu6WTLReMeta || {},
    alias: home1Ceu6WTLReMeta?.alias || [],
    redirect: home1Ceu6WTLReMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/home.vue").then(m => m.default || m)
  },
  {
    name: myOewvayNIWGMeta?.name ?? "incidents-my",
    path: myOewvayNIWGMeta?.path ?? "/incidents/my",
    meta: myOewvayNIWGMeta || {},
    alias: myOewvayNIWGMeta?.alias || [],
    redirect: myOewvayNIWGMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/incidents/my.vue").then(m => m.default || m)
  },
  {
    name: indexC2wjQBRTwpMeta?.name ?? "index",
    path: indexC2wjQBRTwpMeta?.path ?? "/",
    meta: indexC2wjQBRTwpMeta || {},
    alias: indexC2wjQBRTwpMeta?.alias || [],
    redirect: indexC2wjQBRTwpMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/index.vue").then(m => m.default || m)
  },
  {
    name: linksCua9Shw5IZMeta?.name ?? "links",
    path: linksCua9Shw5IZMeta?.path ?? "/links",
    meta: linksCua9Shw5IZMeta || {},
    alias: linksCua9Shw5IZMeta?.alias || [],
    redirect: linksCua9Shw5IZMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/links.vue").then(m => m.default || m)
  },
  {
    name: _91_91tab_93_93YUFz5xYcYjMeta?.name ?? "lnut-home-id-section-pk-tab",
    path: _91_91tab_93_93YUFz5xYcYjMeta?.path ?? "/lnut/home/:id()/:section()/:pk?/:tab?",
    meta: _91_91tab_93_93YUFz5xYcYjMeta || {},
    alias: _91_91tab_93_93YUFz5xYcYjMeta?.alias || [],
    redirect: _91_91tab_93_93YUFz5xYcYjMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/lnut/home/[id]/[section]/[[pk]]/[[tab]].vue").then(m => m.default || m)
  },
  {
    name: _91tab_93E5Yz1eLbCgMeta?.name ?? "lnut-home-subject-id-tab",
    path: _91tab_93E5Yz1eLbCgMeta?.path ?? "/lnut/home/subject/:id()/:tab()",
    meta: _91tab_93E5Yz1eLbCgMeta || {},
    alias: _91tab_93E5Yz1eLbCgMeta?.alias || [],
    redirect: _91tab_93E5Yz1eLbCgMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/lnut/home/subject/[id]/[tab].vue").then(m => m.default || m)
  },
  {
    name: loginxH0Vgy57u8Meta?.name ?? "login",
    path: loginxH0Vgy57u8Meta?.path ?? "/login",
    meta: loginxH0Vgy57u8Meta || {},
    alias: loginxH0Vgy57u8Meta?.alias || [],
    redirect: loginxH0Vgy57u8Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/login.vue").then(m => m.default || m)
  },
  {
    name: logoutpaetVycIHaMeta?.name ?? "logout",
    path: logoutpaetVycIHaMeta?.path ?? "/logout",
    meta: logoutpaetVycIHaMeta || {},
    alias: logoutpaetVycIHaMeta?.alias || [],
    redirect: logoutpaetVycIHaMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: noticiasRYBGGBoFjZMeta?.name ?? "noticias",
    path: noticiasRYBGGBoFjZMeta?.path ?? "/noticias",
    meta: noticiasRYBGGBoFjZMeta || {},
    alias: noticiasRYBGGBoFjZMeta?.alias || [],
    redirect: noticiasRYBGGBoFjZMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/noticias.vue").then(m => m.default || m)
  },
  {
    name: _91tab_93mbYeAsoQqVMeta?.name ?? "profile-settings-tab",
    path: _91tab_93mbYeAsoQqVMeta?.path ?? "/profile/settings/:tab()",
    meta: _91tab_93mbYeAsoQqVMeta || {},
    alias: _91tab_93mbYeAsoQqVMeta?.alias || [],
    redirect: _91tab_93mbYeAsoQqVMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/profile/settings/[tab].vue").then(m => m.default || m)
  },
  {
    name: _91token_938hI16pHzMwMeta?.name ?? "resetPassword-token",
    path: _91token_938hI16pHzMwMeta?.path ?? "/resetPassword/:token()",
    meta: _91token_938hI16pHzMwMeta || {},
    alias: _91token_938hI16pHzMwMeta?.alias || [],
    redirect: _91token_938hI16pHzMwMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/resetPassword/[token].vue").then(m => m.default || m)
  },
  {
    name: licenciapYAuIRy6ylMeta?.name ?? "rules-licencia",
    path: licenciapYAuIRy6ylMeta?.path ?? "/rules/licencia",
    meta: licenciapYAuIRy6ylMeta || {},
    alias: licenciapYAuIRy6ylMeta?.alias || [],
    redirect: licenciapYAuIRy6ylMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/rules/licencia.vue").then(m => m.default || m)
  },
  {
    name: manualwOER7cXCN7Meta?.name ?? "rules-manual",
    path: manualwOER7cXCN7Meta?.path ?? "/rules/manual",
    meta: manualwOER7cXCN7Meta || {},
    alias: manualwOER7cXCN7Meta?.alias || [],
    redirect: manualwOER7cXCN7Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/rules/manual.vue").then(m => m.default || m)
  },
  {
    name: politicasnXsmSPLaMxMeta?.name ?? "rules-politicas",
    path: politicasnXsmSPLaMxMeta?.path ?? "/rules/politicas",
    meta: politicasnXsmSPLaMxMeta || {},
    alias: politicasnXsmSPLaMxMeta?.alias || [],
    redirect: politicasnXsmSPLaMxMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/rules/politicas.vue").then(m => m.default || m)
  },
  {
    name: terminosVyAiehEmOSMeta?.name ?? "rules-terminos",
    path: terminosVyAiehEmOSMeta?.path ?? "/rules/terminos",
    meta: terminosVyAiehEmOSMeta || {},
    alias: terminosVyAiehEmOSMeta?.alias || [],
    redirect: terminosVyAiehEmOSMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/rules/terminos.vue").then(m => m.default || m)
  },
  {
    name: myZOpYLy7lufMeta?.name ?? "schedule-my",
    path: myZOpYLy7lufMeta?.path ?? "/schedule/my",
    meta: myZOpYLy7lufMeta || {},
    alias: myZOpYLy7lufMeta?.alias || [],
    redirect: myZOpYLy7lufMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/schedule/my.vue").then(m => m.default || m)
  },
  {
    name: indexCAKZ60DvVBMeta?.name ?? "school-assistance-entrance",
    path: indexCAKZ60DvVBMeta?.path ?? "/school/assistance/entrance",
    meta: indexCAKZ60DvVBMeta || {},
    alias: indexCAKZ60DvVBMeta?.alias || [],
    redirect: indexCAKZ60DvVBMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/school/assistance/entrance/index.vue").then(m => m.default || m)
  },
  {
    name: indexQOTwtyqbiOMeta?.name ?? "school-assistance-report",
    path: indexQOTwtyqbiOMeta?.path ?? "/school/assistance/report",
    meta: indexQOTwtyqbiOMeta || {},
    alias: indexQOTwtyqbiOMeta?.alias || [],
    redirect: indexQOTwtyqbiOMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/school/assistance/report/index.vue").then(m => m.default || m)
  },
  {
    name: index9OvJCn5SrEMeta?.name ?? "school-sico",
    path: index9OvJCn5SrEMeta?.path ?? "/school/sico",
    meta: index9OvJCn5SrEMeta || {},
    alias: index9OvJCn5SrEMeta?.alias || [],
    redirect: index9OvJCn5SrEMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/school/sico/index.vue").then(m => m.default || m)
  },
  {
    name: adminpiarCt73bo6YmJMeta?.name ?? "school-tracing-adminpiar",
    path: adminpiarCt73bo6YmJMeta?.path ?? "/school/tracing/adminpiar",
    meta: adminpiarCt73bo6YmJMeta || {},
    alias: adminpiarCt73bo6YmJMeta?.alias || [],
    redirect: adminpiarCt73bo6YmJMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/school/tracing/adminpiar.vue").then(m => m.default || m)
  },
  {
    name: characterizationcsaM1XrcfNMeta?.name ?? "school-tracing-characterization",
    path: characterizationcsaM1XrcfNMeta?.path ?? "/school/tracing/characterization",
    meta: characterizationcsaM1XrcfNMeta || {},
    alias: characterizationcsaM1XrcfNMeta?.alias || [],
    redirect: characterizationcsaM1XrcfNMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/school/tracing/characterization.vue").then(m => m.default || m)
  },
  {
    name: coursesFUl32gCqFaMeta?.name ?? "school-tracing-courses",
    path: coursesFUl32gCqFaMeta?.path ?? "/school/tracing/courses",
    meta: coursesFUl32gCqFaMeta || {},
    alias: coursesFUl32gCqFaMeta?.alias || [],
    redirect: coursesFUl32gCqFaMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/school/tracing/courses.vue").then(m => m.default || m)
  },
  {
    name: lowPerformancer9VuT7sYS9Meta?.name ?? "school-tracing-lowPerformance",
    path: lowPerformancer9VuT7sYS9Meta?.path ?? "/school/tracing/lowPerformance",
    meta: lowPerformancer9VuT7sYS9Meta || {},
    alias: lowPerformancer9VuT7sYS9Meta?.alias || [],
    redirect: lowPerformancer9VuT7sYS9Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/school/tracing/lowPerformance.vue").then(m => m.default || m)
  },
  {
    name: performancezHMb2y9A94Meta?.name ?? "school-tracing-performance",
    path: performancezHMb2y9A94Meta?.path ?? "/school/tracing/performance",
    meta: performancezHMb2y9A94Meta || {},
    alias: performancezHMb2y9A94Meta?.alias || [],
    redirect: performancezHMb2y9A94Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/school/tracing/performance.vue").then(m => m.default || m)
  },
  {
    name: resources515cwnZxSWMeta?.name ?? "school-tracing-resources",
    path: resources515cwnZxSWMeta?.path ?? "/school/tracing/resources",
    meta: resources515cwnZxSWMeta || {},
    alias: resources515cwnZxSWMeta?.alias || [],
    redirect: resources515cwnZxSWMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/school/tracing/resources.vue").then(m => m.default || m)
  },
  {
    name: indexlQxXugwV8ZMeta?.name ?? "school-transport",
    path: indexlQxXugwV8ZMeta?.path ?? "/school/transport",
    meta: indexlQxXugwV8ZMeta || {},
    alias: indexlQxXugwV8ZMeta?.alias || [],
    redirect: indexlQxXugwV8ZMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/school/transport/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93NXTlPEKNR8Meta?.name ?? "subject-home-id-tab-subid-slug",
    path: _91_46_46_46slug_93NXTlPEKNR8Meta?.path ?? "/subject/home/:id()/:tab()/:subid?/:slug(.*)*",
    meta: _91_46_46_46slug_93NXTlPEKNR8Meta || {},
    alias: _91_46_46_46slug_93NXTlPEKNR8Meta?.alias || [],
    redirect: _91_46_46_46slug_93NXTlPEKNR8Meta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/subject/home/[id]/[tab]/[[subid]]/[...slug].vue").then(m => m.default || m)
  },
  {
    name: testrCljSyfougMeta?.name ?? "test",
    path: testrCljSyfougMeta?.path ?? "/test",
    meta: testrCljSyfougMeta || {},
    alias: testrCljSyfougMeta?.alias || [],
    redirect: testrCljSyfougMeta?.redirect,
    component: () => import("/tmp/8ddac70b7b64d3d/pages/test.vue").then(m => m.default || m)
  }
]